<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="cancelSubscription"
    >
      <header class="m-the-modal-header">
        <h5> {{ $t('mEditionBillingAcademySalesRecordModalCancelSubscription.title') }} </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionBillingAcademySalesRecordModalCancelSubscription.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademySalesRecordModalCancelSubscription',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingAcademySalesRecordModalCancelSubscription.buttonPrimary'),
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    cancelSubscription () {
      this.buttonPrimary.sending = true
      this.$services.update('ventas', 'cancelSubscription', null, [this.$modal.element.venta.suscripcion_activa])
        .then(response => {
          this.suscripcion = response.data
          this.$modal.updateData()
          this.$alerts.pushAlert('mEditionBillingAcademySalesRecordModalCancelSubscription', 'updateSubscription', 'success', 'a-alert-success')
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionBillingAcademySalesRecordModalCancelSubscription', 'updateSubscription', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
        })
    }
  }
}
</script>
